import { render, staticRenderFns } from "./Forum.vue?vue&type=template&id=02af7d66&scoped=true"
import script from "./Forum.vue?vue&type=script&lang=js"
export * from "./Forum.vue?vue&type=script&lang=js"
import style0 from "./Forum.vue?vue&type=style&index=0&id=02af7d66&prod&scoped=true&lang=css"
import style1 from "./Forum.vue?vue&type=style&index=1&id=02af7d66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02af7d66",
  null
  
)

export default component.exports